import React, {useEffect, useState} from "react";
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import {APIProvider, Map, useMapsLibrary, useMap, AdvancedMarker} from '@vis.gl/react-google-maps';

//CSS
import  styles from './VTMeetingPoint.module.less';

//ICON
import iconmap from "../../../../assets/img/meetingpoint_map.png";
import iconmarkerhotel from "../../../../assets/img/hotel.png";
import iconmarkerpickuppoint from "../../../../assets/img/pickup-point.png";

function VTMeetingPoint({selectedDeparture, hotelID, setHotelID}) {

  const [t,i18n] = useTranslation("vtform");
  const [meetingPointInfo, setMeetingPointInfo] = useState(false);
  const [pickupPointID, setPickupPointID] = useState(false);
  const [pickupTime, setPickupTime] = useState(false);
  const [showMap, setShowMap] = useState(false);

  let groupedOptions=[];

  //Recuperamos datos de los hoteles
  useEffect(() => {
    const postdata = new FormData();
    postdata.append('zone', 'south');
    postdata.append('language', i18n.language);

    //Recuperamos datos dese el servidor
    fetch(process.env.API_URL + "getMeetingPointInfo",{
      method: 'POST',
      body: postdata
    })
      .then((response) =>{
        if (response.ok) { //Verificamos que todo esté bien con la respuesta HTTP
          response.json().then((jsonresponse) => {
            //console.log(jsonresponse);
            if(jsonresponse.success){
              setMeetingPointInfo(jsonresponse.data);
            }else{
              console.log('[ef003] Ha ocurrido un error. Intentelo mas tarde');
            }
          });
        } else {
          //Hubo un problema HTTP 4XX o 5XX
          console.log('[ef002] Ha ocurrido un error. Intentelo mas tarde' );
        }
      })
      .catch((error) => {
        //Hubo un problema que no permitió hacer la solicitud
        console.log('[ef001] Ha ocurrido un error. Intentelo mas tarde');
      });
  }, []);

  const handleHotelChange = (event) => {
    const hotel = event.value;
    const pickupPoint = meetingPointInfo.hotelpickuppoint[event.value];

    setShowMap(false);
    setHotelID(hotel);
    setPickupPointID(pickupPoint);

    //Recuperamos datos dese el servidor (Hora de recogida)
    const postdata = new FormData();
    postdata.append('departure', selectedDeparture);
    postdata.append('pickuppoint', pickupPoint);

    fetch(process.env.API_URL + "getPickUpTime",{
      method: 'POST',
      body: postdata
    })
      .then((response) =>{
        if (response.ok) { //Verificamos que todo esté bien con la respuesta HTTP
          response.json().then((jsonresponse) => {
            //console.log(jsonresponse);
            if(jsonresponse.success){
              setPickupTime(jsonresponse.data);
            }else{
              console.log('[ef003] Ha ocurrido un error. Intentelo mas tarde');
            }
          });
        } else {
          //Hubo un problema HTTP 4XX o 5XX
          console.log('[ef002] Ha ocurrido un error. Intentelo mas tarde' );
        }
      })
      .catch((error) => {
        //Hubo un problema que no permitió hacer la solicitud
        console.log('[ef001] Ha ocurrido un error. Intentelo mas tarde');
      });
  }

  if (Object.keys(meetingPointInfo).length > 0) {
    groupedOptions.push({'label': '',options: [
        {'value': "_1", 'label': t("vtmeetingpoint.El hotel no esta en el listado")},
        {'value': "_2", 'label': t("vtmeetingpoint.No dispongo de hotel todavia")},
        {'value': "_3", 'label': t("vtmeetingpoint.No me alojo en un hotel")}
      ]})
    Object.keys(meetingPointInfo.hotelsselect).map((hotelzone,index) => {
      const grouplabel=hotelzone;
      const groupoptions=[];

      Object.entries(meetingPointInfo.hotelsselect[hotelzone]).map(([key, hotel]) => {
        groupoptions.push({'value': key, 'label': hotel});
      })
      groupedOptions.push({'label': grouplabel,options:groupoptions})
    })
  }

  if (!selectedDeparture) return null;

  return (
    <div className={styles.meetingpoint}>
      <div className={styles.title}>{t('vtmeetingpoint.Información de recogida')}</div>

      <div className={styles.infocontent}>
        <div className={styles.select}>
          <Select
            name="hotels"
            placeholder={t('vtmeetingpoint.Seleccione su alojamiento')}
            isSearchable={true}
            options={groupedOptions}
            onChange={handleHotelChange}
          />
        </div>

        <div className={styles.info}>
          {pickupPointID &&
          <>
            <div className="info"><b>{t('vtmeetingpoint.Hora recogida')}:</b> <span>{pickupTime}</span></div>
            <div className="info"><b>{t('vtmeetingpoint.Lugar recogida')}:</b> <span>{meetingPointInfo.pickuppoints[pickupPointID]['shortname'] != 'undefined' ? meetingPointInfo.pickuppoints[pickupPointID]['shortname'] : ''}</span></div>
            <div className="info"><b>{t('vtmeetingpoint.Dirección')}:</b> <span>{meetingPointInfo.pickuppoints[pickupPointID]['location']['address'] != 'undefined' ? meetingPointInfo.pickuppoints[pickupPointID]['location']['address'] : ''}</span></div>

            {
              !isNaN(parseFloat(meetingPointInfo.hotelsinfo[hotelID]['location']['latitude'])) &&
              !isNaN(parseFloat(meetingPointInfo.hotelsinfo[hotelID]['location']['longitude'])) &&
              !isNaN(parseFloat(meetingPointInfo.pickuppoints[pickupPointID]['location']['latitude'])) &&
              !isNaN(parseFloat(meetingPointInfo.pickuppoints[pickupPointID]['location']['longitude'])) &&

              <div className={styles.maplink}>
                <img className={styles.mapicon} src={iconmap}/>
                <a onClick={()=>setShowMap(!showMap)}>{t('vtmeetingpoint.Ver en mapa')}</a>
              </div>
            }
          </>
          }
        </div>
      </div>

      {showMap &&
        <div className={styles.map}>
          <APIProvider apiKey={process.env.GOOGLE_MAPS_API_KEY}>
            <Map
              defaultZoom={10}
              defaultCenter={{lat: 28.298335, lng: -16.51794}}
              mapTypeId={'roadmap'}
              mapId={'vtmeetignpointmap'}
              gestureHandling={'greedy'}
              disableDefaultUI={true} >
              <Directions
                lat1={meetingPointInfo.hotelsinfo[hotelID]['location']['latitude']}
                lng1={meetingPointInfo.hotelsinfo[hotelID]['location']['longitude']}
                lat2={meetingPointInfo.pickuppoints[pickupPointID]['location']['latitude']}
                lng2={meetingPointInfo.pickuppoints[pickupPointID]['location']['longitude']}
              />
            <AdvancedMarker />
            </Map>
          </APIProvider>
        </div>
      }
    </div>
  );
}

export default VTMeetingPoint;

function Directions({lat1,lng1,lat2,lng2}) {
  const map = useMap();
  const routesLibrary = useMapsLibrary('routes');

  const [directionsService, setDirectionsService] = useState();
  const [directionsRenderer, setDirectionsRenderer] = useState();

  const markerhotel = document.createElement("img");
  markerhotel.src = iconmarkerhotel;
  const markerpickuppoint = document.createElement("img");
  markerpickuppoint.src = iconmarkerpickuppoint;

  // Initialize directions service and renderer
  useEffect(() => {
    if (!routesLibrary || !map) return;
    setDirectionsService(new routesLibrary.DirectionsService());
    setDirectionsRenderer(new routesLibrary.DirectionsRenderer({map,suppressMarkers: true}));
  }, [routesLibrary, map]);

  // Use directions service
  useEffect(() => {
    if (!directionsService || !directionsRenderer) return;

    directionsService
      .route({
        origin: new google.maps.LatLng(lat1,lng1),
        destination: new google.maps.LatLng(lat2,lng2),
        travelMode: google.maps.TravelMode.WALKING,
      })
      .then(response => {
        directionsRenderer.setDirections(response);

        //Marcadores
        const myRoute = response.routes[0].legs[0];

        new google.maps.marker.AdvancedMarkerElement({
          map: map,
          position: myRoute.start_location,
          content:markerhotel
        });

        new google.maps.marker.AdvancedMarkerElement({
          map: map,
          position: myRoute.end_location,
          content:markerpickuppoint
        });
      });

    return () => directionsRenderer.setMap(null);
  }, [directionsService, directionsRenderer]);

  return null;
}

